import { outlinedInputClasses } from '@mui/material'
import { FormikTextField } from 'components/Formik/FormikTextField'
import { RequiredDot } from 'pages/Survey/components/RequiredDot'
import { TextAreaQuestion } from 'pages/Survey/types'
import { useGetObjectTranslation } from 'utils/useGetObjectTranslation'

export const SurveyTextarea = ({ question }: { question: TextAreaQuestion }) => {
  const translatedTitle = useGetObjectTranslation(question.translation, 'title')

  return (
    <FormikTextField
      name={question.id}
      label={
        <>
          {translatedTitle}
          {question.isRequired ? <RequiredDot /> : ''}
        </>
      }
      fullWidth
      variant="outlined"
      multiline
      minRows={4}
      size="small"
      sx={{
        [`& .${outlinedInputClasses.root}`]: { background: (theme) => `${theme.palette.background.paper}!important` },
      }}
      required={question.isRequired}
    />
  )
}
